import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as HeaderActions from '../actions/Header';
import Setting from '../components/Setting';

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    headerActions: bindActionCreators(HeaderActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Setting as any);



// WEBPACK FOOTER //
// ./src/containers/Setting.tsx